export enum CarDetail {
	Color = 'Cor',
	DistanceTraveled = 'Quilometragem',
	Doors = 'Portas',
	Engine = 'Motor',
	FipeCode = 'Código FIPE',
	FipeValue = 'Valor FIPE',
	Fuel = 'Combustível',
	Plate = 'Placa',
	Transmission = 'Transmissão',
	Year = 'Ano',
	ValorInicial = 'Valor inicial',
	ValorCompreAgora = 'Compre agora'
}
